module.exports = __webpack_public_path__ + "static/img/backwithnothing.f904f6bc.png";